import {getAxiosInstance} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js";

/**
 * Per-gateway enable/disable switch + allowed categories.
 * Stored by the backend in the `gateway_rules` site-info row as JSON:
 *   {"digipay": {"enabled": true, "categories": [3, 7]}, "torobpay": {"enabled": false, "categories": []}}
 * Missing gateway / missing flag = enabled, empty categories = no restriction.
 */
export const GATEWAY_RULES_KEY = 'gateway_rules';

// site-info credential key -> gateway name used by the backend (config constants.gateways)
export const gatewayBySiteInfoKey = {
    zarinpal_merchant_id: 'zarinpal',
    payir_token: 'payir',
    idpay_token: 'idpay',
    sama_merchant_gateway: 'sama',
    pasargad_token: 'pasargad',
    mellat_gate_info: 'mellat',
    meli_gate_info: 'meli',
    toman_gate_info: 'toman',
    parsian_gate_info: 'parsian',
    sep_gate_info: 'sep',
    sep_pos_gate_info: 'sep_pos',
    saderat_gate_info: 'saderat',
    torobpay_gate_info: 'torobpay',
    digipay_gate_info: 'digipay',
    cash_on_delivery_categories: 'cashOnDelivery',
};

// installment (BNPL) gateways: category restriction is shown by default for these
export const installmentGateways = ['torobpay', 'digipay'];

export function gatewayOfSiteInfo(name) {
    return gatewayBySiteInfoKey[name] || null;
}

export function parseGatewayRules(value) {
    let rules = value;
    if (typeof value === 'string') {
        try {
            rules = value.trim() ? JSON.parse(value) : {};
        } catch (e) {
            rules = {};
        }
    }
    if (!rules || typeof rules !== 'object' || Array.isArray(rules)) {
        return {};
    }
    return rules;
}

export function gatewayRuleOf(rules, gateway) {
    const rule = (rules && rules[gateway]) || {};
    const categories = Array.isArray(rule.categories) ? rule.categories : [];
    return {
        enabled: rule.enabled !== false && rule.enabled !== 0 && rule.enabled !== '0' && rule.enabled !== 'false',
        categories: categories.map(id => Number(id)).filter(id => id > 0),
    };
}

export function findGatewayRulesRow(siteInfos) {
    return (siteInfos || []).find(item => item && item.name === GATEWAY_RULES_KEY) || null;
}

/**
 * Re-reads the row from the server, replaces only `gateway`'s rule and saves.
 * Returns the axios promise of the update request.
 */
export async function saveGatewayRule(row, gateway, rule) {
    const axios = getAxiosInstance();
    let current = row.value;
    try {
        const fresh = await axios.get(`/site-info/${row.id}`);
        if (fresh && fresh.data && fresh.data.data) current = fresh.data.data.value;
    } catch (e) {
        // fall back to the value we already have
    }
    const rules = parseGatewayRules(current);
    rules[gateway] = {
        enabled: !!rule.enabled,
        categories: (rule.categories || []).map(id => Number(id)).filter(id => id > 0),
    };

    const formData = new FormData();
    formData.append('name', GATEWAY_RULES_KEY);
    formData.append('value', JSON.stringify(rules));
    formData.append('_method', 'PUT');
    return axios.post(`/site-info/${row.id}`, formData);
}
